import React, { useContext, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from "reactstrap";
import { UserContext } from "./userComponents/UserContext";

const NavComponent = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useContext(UserContext);

  const toggle = () => setIsOpen(!isOpen);
  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };
  return (
    <div>
      <Navbar color="dark" dark expand="md">
        <NavbarBrand href="/">HOME</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink href="/movies">MOVIES</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/games">GAMES</NavLink>
            </NavItem>
            {user && (
              <>
                <NavItem>
                  <NavLink href="/fmovies">FORM MOVIES</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/fgames">FORM GAMES</NavLink>
                </NavItem>
              </>
            )}
          </Nav>
          {user && (
            <>
              <NavbarText>
                <NavLink href="/changeP">CHANGE PASSWORD</NavLink>
              </NavbarText>
              <NavbarText>
                <NavLink onClick={handleLogout}>LOGOUT</NavLink>
              </NavbarText>
            </>
          )}
          {user === null && (
            <>
              <NavbarText>
                <NavLink href="/login">LOGIN</NavLink>
              </NavbarText>
              <NavbarText>
                <NavLink href="/register">REGISTER</NavLink>
              </NavbarText>
            </>
          )}
        </Collapse>
      </Navbar>
    </div>
  );
};

export default NavComponent;
